export const personalizationSettings = {
	personalizationSettings: "Configure y personalice sus menús",
	description:
		"Aquí usted personalizará la parte visual y configurará información a ser mostrada en los menús. La personalización es única y se aplicará a todos los menús que usted tiene.",
	yourActiveProducts: "Sus productos activos",
	onlinePostPayment: "Pague en la mesa",
	delivery: "Delivery",
	dineIn: "Pedido en mesa",
	onlineTab: "Comanda online",
	viewMenu: "Menú digital",
	title: "Título",
	placeName: "Nombre del local",
	logo: "Logo",
	coverImg: "Imagen de portada",
	assignedImgInYourMenu: "La imagen asignada aparecerá en su menú.",
	infoImage:
		"Si no agrega una imagen, el encabezado de su producto será el logo y nombre del local.",
	recommendations: "Recomendaciones",
	highQualityImg:
		"Recomendamos que su logo y su imagen de portada estén en alta calidad para mejor aplicación.",
	imgs: "Imágenes",
	primaryColor: "Color de destaque",
	colors: "Colores",
	contrastColor: "Color de contraste",
	secondaryColor: "Color secundario",
	saveCustomization: "Guardar personalización",
	serviceInformation: "Información de atención",
	deliverySettings: "Configuración de delivery",
	pickUpAddress: "Dirección para retirada",
	generateQrCode: "Generar QR Code",
	state: "Estado",
	select: "Seleccione",
	city: "Ciudad",
	enterOrSelect: "Digite o seleccione",
	neighborhood: "Colonia",
	neighborhoodName: "Digite el nombre de la colonia",
	address: "Dirección",
	street: "Nombre de la calle o avenida",
	number: "Número",
	complement: "Complemento",
	typeOfFee: "Tipo de tasa",
	currentHold: "Espera actual",
	holdPlaceholder: "15 minutos",
	baseValue: "Valor base",
	valuePerkm: "Valor por Km",
	visible: "Dejar visible",
	averageTime: "Tiempo promedio de espera",
	status: "Estado (abierto o cerrado)",
	copyOrTypeLink: "Pegue o digite aquí el enlace",
	parameter: "Parámetro",
	searchParameter: "Buscar parámetro",
	parameterValue: "Valor del parámetro",
	value: "Valor",
	newQrCode: "Nuevo QR Code",
	importQrCode: "Importar QR Code",
	downloadQrCode: "Descargar QR Code",
	uniqueFee: "Única",
	basePlusKm: "Base + Variable por Km",
	perRatio: "Tasa por radio",
	addMoreFee: "Agregar otra tasa",
	fromTo: "De {{beginning}} a {{end}}",
	time: "{{minutes}} minutos",
	chairNumber: "Número de la silla",
	tableNumber: "Número de la mesa",
	roomNumber: "Número de la habitación",
	referencePoint: "Punto de referencia",
	savedSuccessfully: "¡Actualizaciones guardadas con éxito!",
	deliveryInfo: "Solicitar información de entrega (opcional)",
	selectInfo: "Seleccione la información que necesita",
	radiusUntil: "Radio hasta",
	complementExample: "Ej: Tienda A",
	chair: "silla",
	table: "mesa",
	room: "habitación",
	reference: "referencia",
	menu: "Menú",
	selectProduct: "Seleccione el producto",
	importSheet: "Importar hoja de cálculo para generar QR Codes",
	importQrCodes: "Importar QrCodes",
	somethingWentWrong: "Algo salió mal",
	couldNotImportSheet:
		"No pudimos importar su hoja de cálculo. Verifique si sigue el modelo propuesto o pida ayuda a nuestro soporte.",
	importInstructions:
		"Después de la importación, los QR Codes serán descargados automáticamente a sus descargas.",
	configSlug: "Configure su slug aquí",
	generateMultipleQrCode: "Generar múltiples QR code",
};
